// 系统管理
const systemManage = [
  {
    path: '/operationLogs',
    name: 'operationLogPage',
    meta: { tag: '操作日志' },
    component: () => import('@/pages/OperationLogPage')
  },
  {
    path: '/smsLog',
    name: 'smsLogPage',
    meta: { tag: '短信记录' },
    component: () => import('@/pages/SmsLogPage')
  },
  {
    path: '/smsSendLog',
    name: 'smsSendLogPage',
    meta: { tag: '发货短信记录' },
    component: () => import('@/pages/SmsSendLogPage')
  },
  {
    path: '/sms-template',
    name: 'smsTemplatePage',
    meta: { tag: '短信模板' },
    component: () => import('@/pages/SmsTemplatePage/index')
  },
  {
    path: '/pushCrmLog',
    name: 'pushCrmLogPage',
    meta: { tag: '推送客服系统工单' },
    component: () => import('@/pages/PushCrmLogPage')
  },
  {
    path: '/pushBbd',
    name: 'pushBbdPage',
    meta: { tag: '帮帮达推送记录' },
    component: () => import('@/pages/PushBbdPage')
  },
  {
    path: '/pushYms',
    name: 'pushYmsPage',
    meta: { tag: '有品推送记录' },
    component: () => import('@/pages/PushYmsPage')
  },
  {
    path: '/snPostDataLog',
    name: 'snPostDataLogPage',
    meta: { tag: '小米SN推送记录' },
    component: () => import('@/pages/SnPostDataLogPage')
  },
  {
    path: '/params-setting',
    name: 'ParamSettingPage',
    meta: { tag: '系统参数配置' },
    component: () => import('@/pages/ParamSettingPage')
  },
  {
    path: '/app-version',
    name: 'AppVersionPage',
    meta: { tag: '中转仓APP版本记录' },
    component: () => import('@/pages/AppVersionPage')
  },
  {
    path: '/pdaOutWarehouseHistory',
    name: 'PdaOutWarehouseHistoryPage',
    meta: { tag: '中转仓出货记录' },
    component: () => import('@/pages/PdaOutWarehouseHistoryPage')
  },
  {
    path: '/equal-change-product',
    name: 'EqualChangeProductPage',
    meta: { tag: '同等置换' },
    component: () => import('@/pages/EqualChangeProductPage')
  }
]

export default systemManage
